import { render, staticRenderFns } from "./YoutubeCard.vue?vue&type=template&id=45406089&scoped=true&"
import script from "./YoutubeCard.vue?vue&type=script&lang=js&"
export * from "./YoutubeCard.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeCard.vue?vue&type=style&index=0&id=45406089&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45406089",
  null
  
)

export default component.exports